<template>
  <m-layout-grid-inner class="app-layout-grid-inner">
    <m-layout-grid-cell :span="12">
      <m-layout-grid class="mdc-layout-grid--height">
        <m-layout-grid-inner style="height: inherit"
          ><slot />
        </m-layout-grid-inner>
      </m-layout-grid>
    </m-layout-grid-cell>
  </m-layout-grid-inner>
</template>

<script>
export default {
  name: "app-layout-grid-inner-custom"
};
</script>

<style lang="scss">
@import "@material/layout-grid/mdc-layout-grid.scss";

// .app-layout-grid-inner {
//   height: inherit;
//   padding-left: 12%;
//   padding-right: 12%;
// }

@media (min-device-width: map-get($mdc-layout-grid-breakpoints, "desktop")) {
  .app-layout-grid-inner {
    height: inherit;
    padding-left: 6%;
    padding-right: 6%;
  }
}

@media (min-device-width: 1440px) {
  .app-layout-grid-inner {
    height: inherit;
    padding-left: 10%;
    padding-right: 10%;
  }

  .app-layout-grid-inner.app-layout-grid-inner--height100 {
    padding-left: 150px;
    padding-right: 150px;
  }
}

@media (min-device-width: map-get($mdc-layout-grid-breakpoints, "desktop")) {
  .app-layout-grid-inner.app-layout-grid-inner--height100
    .mdc-layout-grid--height {
    height: 100%;
  }
}
</style>
